import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import downloadIcon from "../../assets/card-icons/download-purple.svg";
import requestChangesIcon from "../../assets/card-icons/request-change-icon.svg";
import uploadIcon from "../../assets/upload-icon.svg";
import Breadcrumb from "../../components/breadcrumb/Breadcrumb";
import MainContainer from "../../components/container/MainContainer";
import CustomButton from "../../components/CustomButton/CustomButton";
import CustomDocViewer from "../../components/CustomDocViewer/CustomDocViewer";
import ModalWrapper from "../../components/Modal/ModalWrapper";
import { getDetails, postMultipartDetails } from "../../services/http/http.service";
import { hideLoader, showLoader } from "../../store/Loader/loader.slice";
import { useAppDispatch, useAppSelector } from "../../store/storeRequests";
import APIList from "../../utils/constants/APIList";
import BreadcrumbData from "../../utils/constants/BreadcrumbData.constants";
import { APIResponseCodes } from "../../utils/constants/keys.constants";
import StoreSelectors from "../../utils/constants/StoreSelectors.constants";
import encrypt from "../../utils/helpers/encrypt";
import handleDownloadDocx from "../../utils/helpers/handleDownloadDocx";
import openURL from "../../utils/helpers/openURL";
import transformString from "../../utils/helpers/transformString";
import "./legal.css";
import { NavList } from "../../utils/constants/navigation";
import { message } from "../../utils/constants/Messages";
import { setActionableAlert, setAlertMode, setMessage, setShowAlert } from "../../store/Alert/alert.slice";
const doc = require("../../assets/docs/Letter-of-Intent.docx");

const Legal: React.FunctionComponent<any> = () => {
  const sops = ["Name here one", "Name here two", "Name here three", "Name here four", "Name here three"];

  const Categories = [
    { id: 1, value: "non commercial transactions" },
    { id: 4, value: "e-cas" },
    { id: 2, value: "commercial transactions" },
    { id: 3, value: "lamf" },
  ];

  const { access } = useAppSelector(StoreSelectors.USER_STATE);

  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const isUIMounted = useRef(false);
  const requestModalRef = useRef();
  const inputRef = useRef(null);

  const [currentModal, setCurrentModal] = useState<"request" | "submit" | "">("");
  const [currentModalCategory, setCurrentModalCategory] = useState("");
  const [files, setFiles] = useState<
    Array<{
      file: File | null;
      changeFile: File | null;
      requestingChange: false;
      category: "ecas" | "nonCommercial" | "commercial" | "lamf";
      uploadedPath: string;
      id: number;
      req_id: null | number;
      legal_approve_state?: "pending" | "processed" | "failed";
    }>
  >([
    {
      category: "ecas",
      file: null,
      changeFile: null,
      requestingChange: false,
      uploadedPath: "",
      id: 4,
      legal_approve_state: "pending",
      req_id: null,
    },
    {
      category: "nonCommercial",
      file: null,
      changeFile: null,
      requestingChange: false,
      uploadedPath: "",
      id: 1,
      legal_approve_state: "pending",
      req_id: null,
    },
    {
      category: "commercial",
      file: null,
      changeFile: null,
      requestingChange: false,
      uploadedPath: "",
      id: 2,
      legal_approve_state: "pending",
      req_id: null,
    },
    {
      category: "lamf",
      file: null,
      changeFile: null,
      requestingChange: false,
      uploadedPath: "",
      id: 3,
      legal_approve_state: "pending",
      req_id: null,
    },
  ]);
  const [err, setErr] = useState({ show: false, message: "" });
  const [categoriesToShow, setCategoriesToShow] = useState({
    nonCommercial: false,
    ecas: false,
    commercial: false,
    lamf: false,
  } as { nonCommercial: any; ecas: any; commercial: any; lamf: any });
  const [APIData, setAPIData] = useState([]);

  const getPageData = async () => {
    if (!access.hasProdAccess) return;

    const response = await getDetails(APIList.GET_ALL_PROD_CART_ITEMS, getPageData);

    let temp = {
      nonCommercial: false,
      ecas: false,
      commercial: false,
      lamf: false,
    };

    if (response.statusCode === APIResponseCodes.SUCCESS) {
      response.data.api_list.forEach((item: any) => {
        if (temp.nonCommercial === false && transformString(item.group_type, " ", "") === "noncommercialtransactions") {
          temp = { ...temp, nonCommercial: true };
        } else if (temp.ecas === false && transformString(item.group_type, " ", "") === "e-cas") {
          temp = { ...temp, ecas: true };
        } else if (temp.commercial === false && transformString(item.group_type, " ", "") === "commercialtransactions") {
          temp = { ...temp, commercial: true };
        } else if (temp.lamf === false && transformString(item.group_type, " ", "") === "lamf") {
          temp = { ...temp, lamf: true };
        }
      });

      let tempArr: any = [];

      files.forEach((file) => {
        response.data.info.forEach((info: any) => {
          if (file.id === info.id) {
            tempArr.push({
              ...file,
              legal_approve_state: info.legal_approve_state || "pending",
              uploadedPath: info.legal_approve_state !== 'failed' ? info.path : '',
              requestingChange: info.req_id !== null ? true : false,
              req_id: info.req_id,
            });
          }
        });
      });

      setCategoriesToShow(temp);
      setAPIData(response.data);
      setFiles(tempArr);
    }
  };

  useEffect(() => {
    if (access.hasProdAccess === true) isUIMounted.current = false;

    if (isUIMounted.current === true) {
      return;
    }

    getPageData();

    isUIMounted.current = true;
  }, [access]);

  /** Open modal */
  const handleRequestChanges = (modalName: "request" | "submit", category: "ecas" | "nonCommercial" | "commercial" | "lamf") => {
    if (files.filter((file) => file.category === category)[0].req_id !== null && modalName === "request") {
      navigate(`${NavList.SUPPORT_TICKET_VIEW}${encodeURIComponent(encrypt(`${files.filter((file) => file.category === category)[0].req_id}`))}`);
      return;
    }

    if (typeof requestModalRef.current !== "undefined") {
      const modal: { toggleModalWrapper: Function } = requestModalRef.current;
      modal.toggleModalWrapper(true);
      setCurrentModal(modalName);
      setCurrentModalCategory(category);
    }
  };

  /** Open file choose window*/
  const clickOnRef = (data: any) => {
    if (currentModal === "request") {
      if (inputRef.current !== null) {
        const input: { click: Function } = inputRef.current;
        input.click();
      }
    }

    if (currentModal === "submit") {
      if (data.legal_approve_state !== "failed" && data.uploadedPath.length !== 0) return;
      if (inputRef.current !== null) {
        const input: { click: Function } = inputRef.current;
        input.click();
      }
    }
  };

  /** Validate file and set file to the state */
  const handleFileInput = (ev: ChangeEvent<HTMLInputElement>) => {
    setErr({ show: false, message: "" });

    if (ev.target.files === null || ev.target.files.length === 0) {
      let result = files.filter((item) => (item.category === currentModalCategory ? { ...item, file: null } : item));
      setFiles(result);
      ev.target.value = "";
      setErr({ show: true, message: "File is required" });
      return;
    } else if (ev.target.files[0].size > 10000000) {
      let result = files.filter((item) => (item.category === currentModalCategory ? { ...item, file: null } : item));
      setFiles(result);
      ev.target.value = "";
      setErr({ show: true, message: "File size must be less than 10MB" });
      return;
    } else if (!["pdf", "doc", "docx"].includes(ev.target.files[0].name.split(".")[ev.target.files[0].name.split(".").length - 1].toLowerCase())) {
      let result = files.filter((item) => (item.category === currentModalCategory ? { ...item, file: null } : item));
      setFiles(result);
      ev.target.value = "";
      setErr({ show: true, message: "Only acceppts PDF, word files" });
      return;
    } else {
      const arr: any = [];
      const file = ev.target.files[0];
      currentModal === "request"
        ? files.forEach((item) => (item.category === currentModalCategory ? arr.push({ ...item, changeFile: file, requestingChange: true }) : arr.push(item)))
        : files.forEach((item) => (item.category === currentModalCategory ? arr.push({ ...item, file: file }) : arr.push(item)));
      setSelectedLocalFile(file);
      setFiles(arr);
    }
  };

  /** Reset state of file variables */
  const resetFile = () => {
    setErr({ show: false, message: "" });
    setFiles([
      {
        category: "ecas",
        file: null,
        changeFile: null,
        requestingChange: false,
        uploadedPath: "",
        id: 4,
        req_id: null,
      },
      {
        category: "nonCommercial",
        file: null,
        changeFile: null,
        requestingChange: false,
        uploadedPath: "",
        id: 1,
        req_id: null,
      },
      {
        category: "commercial",
        file: null,
        changeFile: null,
        requestingChange: false,
        uploadedPath: "",
        id: 2,
        req_id: null,
      },
      {
        category: "lamf",
        file: null,
        changeFile: null,
        requestingChange: false,
        uploadedPath: "",
        id: 3,
        req_id: null,
      },
    ]);
    if (inputRef.current !== null) {
      const input: { value: string } = inputRef.current;
      input.value = "";
    }
  };

  /** Close modal */
  const onDownload = (type: 1 | 2 | 3 | 4) => {
    openURL(doc, "download", "file");
  };

  /** Close modal */
  const onCloseModal = () => setErr({ show: false, message: "" });

  const handleViewFile = (file: File | null) => {
    if (typeof file === "string") {
      openURL(URL.createObjectURL(file), "open");
      return;
    }

    if (file !== null) {
      openURL(URL.createObjectURL(file), "open");
    }
  };

  const prepareData = (index: "nonCommercial" | "ecas" | "commercial" | "lamf") => {
    const keys = {
      nonCommercial: "nct_file",
      ecas: "ecas_file",
      commercial: "ct_file",
      lamf: "lamf_file",
    };

    let payload = {};

    files.forEach((item) => {
      if (item.file !== null && item.category === index) {
        payload = { key: keys[index], file: item.file, filename: item.file.name };
      }
    });

    return Object.keys(payload).length === 0 ? null : payload;
  };

  /** */
  const handleProceed = async () => {

    dispatch(showLoader(message.SUBMIT_SIGN_OFF));

    try {
      const formData = new FormData();

      let index: "nonCommercial" | "ecas" | "commercial" | "lamf";
      let valid = false;

      for (index in categoriesToShow) {
        if (categoriesToShow[index]) {
          let response: any = prepareData(index);

          if (response !== null) {
            valid = true;
            formData.append(response.key, response.file, response.filename);
          }
        }
      }

      if (!valid) {
        navigate(NavList.PRODUCTION_COMMERCIALS);
        dispatch(hideLoader());
        return;
      }

      const response = await postMultipartDetails(APIList.LEGAL_SIGNOFF, formData);
      if (response.statusCode === APIResponseCodes.SUCCESS) {
        navigate(NavList.PRODUCTION_COMMERCIALS);
      }
    } catch (error) {
      dispatch(hideLoader());
    }
  };


  const handleRequest = async (item: any) => {
    dispatch(showLoader(message.SUBMIT_REQUEST));
    let apiType: any = Categories.filter((type) => (type.id === item.id ? type.value : ""))[0].value;
    const formdata = new FormData();
    formdata.append("data", encrypt({ api_type: apiType, request_type: "Legal" }));
    formdata.append("files", item.changeFile, item.changeFile.name);
    try {
      const response = await postMultipartDetails(APIList.LEGAL_REQUEST, formdata);
      dispatch(hideLoader());
      if (Object.values(response.data).length === 0) {
        return;
      }
      if (response.statusCode === APIResponseCodes.SUCCESS) {
        dispatch(setActionableAlert(false));
        dispatch(setAlertMode(true));
        dispatch(setMessage("Request submitted successfully"));
        dispatch(setShowAlert(true));
        navigate(NavList.SUPPORT_REQUESTS);
      }
    } catch (error) {
      dispatch(hideLoader());
    }
  };

  const removeFile = async (category: "ecas" | "nonCommercial" | "commercial" | "lamf") => {
    const temp: Array<{
      file: File | null;
      changeFile: File | null;
      requestingChange: false;
      category: "ecas" | "nonCommercial" | "commercial" | "lamf";
      uploadedPath: string;
      id: number;
      req_id: null | number;
    }> = [];

    files.forEach((file) => {
      if (currentModal === "submit") {
        category === file.category ? temp.push({ ...file, file: null }) : temp.push(file);
        if (inputRef.current !== null) {
          const ref: { value: string } = inputRef.current;
          ref.value = "";
        }
      }
      if (currentModal === "request") {
        category === file.category ? temp.push({ ...file, changeFile: null }) : temp.push(file);
        if (inputRef.current !== null) {
          const ref: { value: string } = inputRef.current;
          ref.value = "";
        }
      }
    });
    setFiles(temp);
    setSelectedLocalFile(null);
  };

  const [showDocViewer, setShowDocViewer] = useState(false);
  const [selectedFileURL, setSelectedFileURL] = useState("");
  const [selectedLocalFile, setSelectedLocalFile] = useState<any>(null);

  const handleOpenDocViewer = (fileUrl: string) => {
    setSelectedFileURL(fileUrl);
    setShowDocViewer(true);
  };

  const handleCloseDocViewer = () => {
    setShowDocViewer(false);
  };

  return (
    <MainContainer>
      <Breadcrumb routes={BreadcrumbData.legal_formalities} />
      <h2 className="text-capitalize mf-active-header">Legal Formalities</h2>

      {APIData.length === 0 && (
        <div className="text-center py-3 no-data-with-view">
          <p className="mb-0 weight-500 font-14 text-primary-color mb-2">No APIs added to cart...</p>
          <button onClick={() => navigate(NavList.API_LISTING_PRODUCTION)} className="border-0 font-13 text-sec-color weight-500">
            View approved APIs {">"}
          </button>
        </div>
      )}

      {categoriesToShow.ecas && (
        <div className="card-shadow bg-white legal-card d-flex mb-4">
          <div className="">
            {/* <p className="mb-0 text-primary-color weight-500 text-capitalize font-16 mb-3">E-CAS</p> */}
            <p className="mb-0 text-primary-color weight-500 text-capitalize font-16 mb-3">Read Only</p>
            <button onClick={() => onDownload(1)} className="download-template-btn d-flex align-items-center">
              <img width="14" height="14" src={downloadIcon} alt="download" />
              <p className="mb-0 font-13 weight-500 ms-3">Download Standard Template</p>
            </button>
          </div>

          <div className="legal-actions d-flex">
            <button onClick={() => handleRequestChanges("request", "ecas")} className="legal-changes-btn text-capitalize border-0 d-flex align-items-center me-2">
              {files.filter((file) => file.category === "ecas")[0].req_id === null ? (
                <>
                  <img width="18" height="18" src={requestChangesIcon} alt="request changes" />
                  <p className="mb-0 font-13 weight-500 ms-2">request changes</p>
                </>
              ) : (
                <p className="mb-0 font-13 weight-500 ms-2">Go to request</p>
              )}
            </button>
            <button onClick={() => handleRequestChanges("submit", "ecas")} className="legal-signoff-btn text-capitalize text-white border-0 primary-bg-color font-13 weight-400 ms-2">
              {files.filter((file) => file.category === "ecas")[0].uploadedPath.length === 0 ? "Submit Sign Off" : "Submitted  ✔"}
            </button>
          </div>
        </div>
      )}

      {categoriesToShow.lamf && (
        <div className="card-shadow bg-white legal-card d-flex mb-4 mt-4 ">
          <div className="">
            <p className="mb-0 text-primary-color weight-500 text-capitalize font-16 mb-3">LAMF</p>
            <button onClick={() => onDownload(2)} className="download-template-btn d-flex align-items-center">
              <img width="14" height="14" src={downloadIcon} alt="download" />
              <p className="mb-0 font-13 weight-500 ms-3">Download Standard Template</p>
            </button>
          </div>

          <div className="legal-actions d-flex">
            <button onClick={() => handleRequestChanges("request", "lamf")} className="legal-changes-btn text-capitalize border-0 d-flex align-items-center me-2">
              {files.filter((file) => file.category === "lamf")[0].req_id === null ? (
                <>
                  <img width="18" height="18" src={requestChangesIcon} alt="request changes" />
                  <p className="mb-0 font-13 weight-500 ms-2">request changes</p>
                </>
              ) : (
                <p className="mb-0 font-13 weight-500 ms-2">Go to request</p>
              )}
            </button>
            <button onClick={() => handleRequestChanges("submit", "lamf")} className="legal-signoff-btn text-capitalize text-white border-0 primary-bg-color font-13 weight-400 ms-2">
              {files.filter((file) => file.category === "lamf")[0].uploadedPath.length === 0 ? "Submit Sign Off" : "Submitted  ✔"}
            </button>
          </div>
        </div>
      )}

      {categoriesToShow.nonCommercial && (
        <div className="card-shadow bg-white legal-card d-flex mb-4 mt-4">
          <div className="">
            <p className="mb-0 text-primary-color weight-500 text-capitalize font-16 mb-3">Non Commercial Transactions</p>
            <button onClick={() => onDownload(3)} className="download-template-btn d-flex align-items-center">
              <img width="14" height="14" src={downloadIcon} alt="download" />
              <p className="mb-0 font-13 weight-500 ms-3">Download Standard Template</p>
            </button>
          </div>

          <div className="legal-actions d-flex">
            <button onClick={() => handleRequestChanges("request", "nonCommercial")} className="legal-changes-btn text-capitalize border-0 d-flex align-items-center me-2">
              {files.filter((file) => file.category === "nonCommercial")[0].req_id === null ? (
                <>
                  <img width="18" height="18" src={requestChangesIcon} alt="request changes" />
                  <p className="mb-0 font-13 weight-500 ms-2">request changes</p>
                </>
              ) : (
                <p className="mb-0 font-13 weight-500 ms-2">Go to request</p>
              )}
            </button>
            <button onClick={() => handleRequestChanges("submit", "nonCommercial")} className="legal-signoff-btn text-capitalize text-white border-0 primary-bg-color font-13 weight-400 ms-2">
              {files.filter((file) => file.category === "nonCommercial")[0].uploadedPath.length === 0 ? "Submit Sign Off" : "Submitted  ✔"}
            </button>
          </div>
        </div>
      )}

      {categoriesToShow.commercial && (
        <div className="card-shadow bg-white legal-card d-flex mb-5 mt-4">
          <div className="">
            <p className="mb-0 text-primary-color weight-500 text-capitalize font-16 mb-3">Commercial Transactions</p>
            <button onClick={() => onDownload(4)} className="download-template-btn d-flex align-items-center">
              <img width="14" height="14" src={downloadIcon} alt="download" />
              <p className="mb-0 font-13 weight-500 ms-3">Download Standard Template</p>
            </button>
          </div>

          <div className="legal-actions d-flex">
            <button onClick={() => handleRequestChanges("request", "commercial")} className="legal-changes-btn text-capitalize border-0 d-flex align-items-center me-2">
              {files.filter((file) => file.category === "commercial")[0].req_id === null ? (
                <>
                  <img width="18" height="18" src={requestChangesIcon} alt="request changes" />
                  <p className="mb-0 font-13 weight-500 ms-2">request changes</p>
                </>
              ) : (
                <p className="mb-0 font-13 weight-500 ms-2">Go to request</p>
              )}
            </button>
            <button onClick={() => handleRequestChanges("submit", "commercial")} className="legal-signoff-btn text-capitalize text-white border-0 primary-bg-color font-13 weight-400 ms-2">
              {files.filter((file) => file.category === "commercial")[0].uploadedPath.length === 0 ? "Submit Sign Off" : "Submitted  ✔"}
            </button>
          </div>
        </div>
      )}

      {APIData.length !== 0 && (
        <div className="button-width-container mx-auto mb-5">
          <CustomButton type="button" onClick={handleProceed}
          >
            Proceed
          </CustomButton>
        </div>
      )}

      {/* Submit Sign Off */}
      <div className="legal-modal-container">
        <ModalWrapper callback={onCloseModal} ref={requestModalRef} title={currentModal === "request" ? "Request Changes" : "Submit Sign Off"} className="legal-modal-wrapper">
          <p className="mb-0 legal-sop-header font-16 weight-500 mb-3">SOP(s)</p>

          {sops.map((item, index) => (
            <div className="sop-text d-flex" key={index}>
              <p className="mb-0 font-14 weight-500 me-2">{index + 1}.</p>
              <p className="mb-0 font-14 weight-500">{item}</p>
            </div>
          ))}

          {files.map((item, index) => {
            return item.category === currentModalCategory ? (
              <div key={index} className="legal-modal-actions mt-3 d-flex align-items-center justify-content-between position-relative">
                <div className="legal-modal-left d-flex align-items-center">
                  {currentModal !== "request" && item.legal_approve_state === "failed" && (
                    <button onClick={() => clickOnRef(item)} className="legal-modal-btn legal-changes-btn d-flex">
                      <img width={18} height={18} src={uploadIcon} alt="upload" />
                      <p className="mb-0 text-capitalize font-13 weight-500 ms-2">Upload File</p>
                    </button>
                  )}
                  {item.legal_approve_state === "pending" && currentModal === "submit" && (
                    <button disabled={item.uploadedPath.length !== 0} onClick={() => clickOnRef(item)} className="legal-modal-btn legal-changes-btn d-flex">
                      <img width={18} height={18} src={uploadIcon} alt="upload" />
                      <p className="mb-0 text-capitalize font-13 weight-500 ms-2">Upload File</p>
                    </button>
                  )}
                  {currentModal === "request" && (
                    <button onClick={() => clickOnRef(item)} className="legal-modal-btn legal-changes-btn d-flex">
                      <img width={18} height={18} src={uploadIcon} alt="upload" />
                      <p className="mb-0 text-capitalize font-13 weight-500 ms-2">Upload File</p>
                    </button>
                  )}
                  <input
                    onInput={handleFileInput}
                    accept="application/msword, application/pdf, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                    ref={inputRef}
                    type="File"
                    className="d-none"
                  />
                  {err.message.length !== 0 && <p className="mb-0 text-primary-color font-13 weight-400 ms-3">{err.message}</p>}
                  {currentModal === "submit" && err.message.length === 0 && item.file === null && item.uploadedPath.length === 0 && (
                    <p className="mb-0 text-primary-color font-13 weight-400 ms-3">Max file size 10MB</p>
                  )}
                  {currentModal === "request" && err.message.length === 0 && item.changeFile === null && <p className="mb-0 text-primary-color font-13 weight-400 ms-3">Max file size 10MB</p>}
                  {currentModal === "request" && (
                    <p onClick={() => handleViewFile(item.changeFile)} className="mb-0 text-primary-color font-13 weight-400 ms-3 legal-filename pe-1">
                      {item.changeFile !== null ? item.changeFile.name : ""}
                    </p>
                  )}

                  {currentModal === "submit" && item.uploadedPath.length === 0 && err.message.length === 0 && (
                    <div className="d-flex align-items-center">
                      <p onClick={() => item.file && (item.file.type === "application/pdf" ?
                        handleOpenDocViewer(item.file !== null ? "" : item.uploadedPath) :
                        openURL(URL.createObjectURL(item.file), "open"))} className="mb-0 text-primary-color font-13 weight-400 ms-3 legal-filename pe-1 me-2">
                        {item.file !== null ? item.file.name : ""}
                      </p>
                      {(item.uploadedPath.length !== 0 || item.file !== null) && (
                        <div onClick={() =>
                          item.file && (item.file.type === "application/pdf" ?
                            handleOpenDocViewer(item.file !== null ? "" : item.uploadedPath) :
                            openURL(URL.createObjectURL(item.file), "open"))
                        } className="mf-view-option"></div>
                      )}
                      {item.uploadedPath.length === 0 && item.file !== null && <div onClick={() => removeFile(item.category)} className="mf-delete-option ms-2"></div>}
                    </div>
                  )}

                  {currentModal === "submit" && item.uploadedPath.length !== 0 && (
                    <div className="legal-signoff-upload position-relative">
                      <p className="mb-0 text-primary-color font-13 weight-400 ms-3 legal-filename pe-1">{item.file !== null ? item.file.name : item.uploadedPath}</p>
                      {item.uploadedPath.length === 0 && <div onClick={resetFile} className="mf-delete-option"></div>}
                      <div onClick={() =>
                        item.uploadedPath.includes("pdf") ?
                          handleOpenDocViewer(item.file !== null ? "" : item.uploadedPath) :
                          handleDownloadDocx(item.uploadedPath)
                      } className="mf-view-option"></div>
                    </div>
                  )}
                </div>
                {currentModal === "request" && item.changeFile !== null && (
                  <div className="legal-modal-right">
                    <button onClick={() => handleRequest(item)} className="legal-modal-btn legal-submit-btn text-capitalize font-13 weight-500 text-white">
                      proceed
                    </button>
                  </div>
                )}
              </div>
            ) : null;
          })}
        </ModalWrapper>
      </div>

      <div className="legal-doc-viewer">{showDocViewer && <CustomDocViewer url={selectedFileURL} uploadedFile={selectedLocalFile} onClose={handleCloseDocViewer} />}</div>
    </MainContainer>
  );
};

export default Legal;
